import React, { useEffect, useState } from 'react';
import { supabase } from './lib/supabase';
import Header from './components/Header';
import RankingItem from './components/RankingItem';
import SearchRank from './components/SearchRank';
import PointGuide from './components/PointGuide';
import SafeIcon from './common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

// Fallback data in case Supabase view is not accessible
const fallbackData = [
  { rank: 1, member_name: 'Yamada T.', total_points: 3450 },
  { rank: 2, member_name: 'Suzuki M.', total_points: 3100 },
  { rank: 3, member_name: 'Sato K.', total_points: 2980 },
  { rank: 4, member_name: 'Takahashi Y.', total_points: 2850 },
  { rank: 5, member_name: 'Ito H.', total_points: 2100 },
  { rank: 6, member_name: 'Watanabe', total_points: 1950 },
  { rank: 7, member_name: 'Nakamura', total_points: 1800 },
  { rank: 8, member_name: 'Kobayashi', total_points: 1650 },
  { rank: 9, member_name: 'Kato', total_points: 1500 },
  { rank: 10, member_name: 'Yoshida', total_points: 1420 },
];

function App() {
  const [ranking, setRanking] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState(new Date());

  const currentMonthStr = new Date().toISOString().slice(0, 7); // 'YYYY-MM'

  const fetchRanking = async () => {
    try {
      const { data, error } = await supabase
        .from('remo_monthly_ranking')
        .select('*')
        .eq('year_month', currentMonthStr)
        .order('rank', { ascending: true })
        .limit(10);

      if (error) {
        console.warn('Using fallback data due to fetch error:', error.message);
        setRanking(fallbackData);
      } else if (data && data.length > 0) {
        setRanking(data);
      } else {
        // If query succeeds but no data, use fallback for visual testing
        setRanking(fallbackData);
      }
    } catch (err) {
      console.error('Fetch error:', err);
      setRanking(fallbackData);
    } finally {
      setLoading(false);
      setLastUpdated(new Date());
    }
  };

  useEffect(() => {
    fetchRanking();

    // Polling every 30 seconds
    const interval = setInterval(() => {
      fetchRanking();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const maxPoints = ranking.length > 0 ? ranking[0].total_points : 0;

  return (
    <div className="min-h-screen bg-[#1A1A2E] p-2 md:p-4 flex justify-center font-sans">
      <div className="w-full max-w-md bg-[#1A1A2E] flex flex-col relative">
        
        <Header />

        <div className="flex-grow flex flex-col gap-2">
          {/* Top 10 List - scrollable for compact iframes */}
          <div className="bg-brand-card rounded-xl p-3 border border-gray-700 shadow-lg relative">
            <div className="flex justify-between items-center mb-3 px-1">
              <h2 className="text-sm font-bold text-gray-200">TOP 10</h2>
              <div className="text-[10px] text-gray-500 flex items-center gap-1">
                <SafeIcon icon={FiIcons.FiClock} />
                更新: {lastUpdated.toLocaleTimeString('ja-JP', { hour: '2-digit', minute:'2-digit' })}
              </div>
            </div>

            {loading && ranking.length === 0 ? (
              <div className="flex justify-center items-center py-10">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-main"></div>
              </div>
            ) : (
              <div className="max-h-[300px] md:max-h-[400px] overflow-y-auto pr-1 hide-scrollbar">
                {ranking.map((item) => (
                  <RankingItem key={item.rank} data={item} maxPoints={maxPoints} />
                ))}
              </div>
            )}
          </div>

          <SearchRank currentMonthStr={currentMonthStr} top1Point={maxPoints} />
          <PointGuide />
        </div>

      </div>
    </div>
  );
}

export default App;